import React, { Component } from "react";
import { BiMap } from "react-icons/bi";
import { Row } from "reactstrap";
import { Skeleton } from "antd";

import "./CounterPin.scss";
import { getLocalStorageValues } from "../../../services/boat";
import { generatePin, getBoatHouse, getPinList } from "../../../services/CounterPinService";
import NavBar from "../../common/forms/NavbarCopy";
import { AutocompleteValue } from "../../common/forms/Autocomplete";
import { AddNotification } from "../../Methods/Notificaition";

class CounterPin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      isBoatHouse: false,
      openNotification: false,
      message: "",
      variant: "info",
      BoatHouseList: [],
      BoatHouseName: "",
      BoatHouseId: "",
      PinList: [],
      generatedPin: "",
    };
  }
  componentDidMount = async () => {
    await this.setState({ loading: true });
    await this.getBoatHouseData();
    await this.getPinListData();
    await this.setState({ loading: false });
  };
  getBoatHouseData = async () => {
    const res = await getBoatHouse();
    if (res.data?.StatusCode == 1 && res.data?.Response) {
      await this.setState({ BoatHouseList: res.data.Response });
    } else {
      await this.setState({ BoatHouseList: [] });
    }
  };
  getPinListData = async () => {
    await this.setState({ loading: true });
    let data = {
      QueryType: "Pin",
      ServiceType: "PinList",
      BookingDate: new Date(),
      BookingId: "0",
      BoatHouseId: "0",
      UserId: getLocalStorageValues("UserId"),
    };

    const res = await getPinList(data);
    if (res.data?.Table?.length > 0) {
      await this.setState({ PinList: res.data.Table });
    } else {
      await this.setState({ PinList: [] });
    }
    await this.setState({ loading: false });
  };

  handleChangeBoatHouse = async (e) => {
    await this.setState({
      BoatHouseName: e.BoatHouseName,
      BoatHouseId: e.BoatHouseId,
    });
  };
  generatePinData = async () => {
    if (!getLocalStorageValues("MobileNo") || !getLocalStorageValues("UserId")) {
      return await this.setState({ openNotification: true, variant: "info", message: "User info not found, Check Your Profile" });
    }
    if (this.state.BoatHouseId !== "" && this.state.BoatHouseName !== "") {
      let data = {
        BoatHouseId: this.state.BoatHouseId,
        BoatHouseName: this.state.BoatHouseName,
        BookingDate: new Date(),
        UserId: getLocalStorageValues("UserId"),
        MobileNo: getLocalStorageValues("MobileNo"),
        BookingType: "U",
        BookingMedia: "PW",
      };
      const res = await generatePin(data);
      if (res.data?.StatusCode == 1 && res.data?.Response) {
        await this.setState({ generatedPin: res.data.Response, openNotification: true, variant: "success", message: "Pin genereted successfully" });
        await this.getPinListData();
      } else {
        await this.setState({ generatedPin: "", openNotification: true, variant: "info", message: res.data?.Response });
        await this.getPinListData();
      }
    } else {
      return await this.setState({ openNotification: true, variant: "info", message: "Select Boat House" });
    }
  };
  render() {
    return (
      <>

      <div className="counterPinMasterDiv">
        <NavBar {...this.props} />
        <AddNotification visible={this.state.openNotification} variant={this.state.variant} message={this.state.message} onClose={() => this.setState({ openNotification: false })} />
        <div id="generate-pin">
          <div className="generate-pin row">
            {getLocalStorageValues("MobileNo") ? (
              <>
                <div className="col-lg-4 col-md-12 col-sm-12  generatepin-container mt-5">
                  <h5 className="pin-heading">Generate Counter Pin</h5>
                  <div className="boat-house">
                    <Row
                      className="hotel-search"
                      onClick={() => {
                        this.setState((prev) => ({
                          isBoatHouse: !prev.isBoatHouse,
                        }));
                      }}
                    >
                      <div className="hotel-wrapper">
                        <label class="labelcolor">BOAT HOUSE</label>
                        <br />
                        <AutocompleteValue menuIsOpen={this.state.isBoatHouse} field="BoatHouseName" name="name" placeholder={"Select"} getOptionValue={(option) => option.BoatHouseId} getOptionLabel={(option) => option.BoatHouseName} options={this.state.BoatHouseList} value={this.state.BoatHouseList} onChange={(e) => this.handleChangeBoatHouse(e)} autoComplete="off" />

                        <div class="hotelicon">
                          <BiMap />
                        </div>
                      </div>
                    </Row>
                  </div>

                  <div className="pin row mt-5 mb-5">
                    <div className="col">
                      <button className="btn btn-success pin-btn ml-2" onClick={this.generatePinData}>
                        Pin
                      </button>
                    </div>
                    <div className="col text-right">{this.state.generatedPin && <span className="pin-number mr-2">{this.state.generatedPin}</span>}</div>
                  </div>
                </div>
                <div className="col col-lg-4 col-md-12 col-sm-12 availablepin-container mt-5">
                  <h5 className="pin-heading">Generated Pin List</h5>

                  <div className="pin-table mt-4 ">
                    <Skeleton active loading={this.state.loading}>
                      {this.state.PinList?.length > 0 ? (
                        <>
                          <table className="table">
                            <tr>
                              <th> Boat House Name</th>
                              <th>Booking Pin</th>
                              <th>Status</th>
                            </tr>

                            <tbody>
                              {this.state?.PinList.map((pin) => {
                                return (
                                  <tr>
                                    <td>{pin.BoatHouseName}</td>
                                    <td>{pin.BookingPin}</td>
                                    <td>{pin.PinStatus}</td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </>
                      ) : (
                        <>
                          <h5 className="text-center">No data found !</h5>
                        </>
                      )}
                    </Skeleton>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="mt-5  ">
                  <div className="mobile-info px-4 py-5"> Update your MobileNo to access this feature!</div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      </>
    );
  }
}

export default CounterPin;
